import { EditorType } from '../fixtures/plans';
import { getGlobalObject } from './get-global-object';

function getSiteHost() {
  const globalObj = getGlobalObject();
  if (globalObj?.commonConfig) {
    return globalObj.commonConfig.host || 'EDITOR';
  }

  return 'EDITOR';
}

export function isHostStudio() {
  return getSiteHost() === 'STUDIO';
}

export function isHostEditor3() {
  return getSiteHost() === 'EDITOR3';
}

export function isHostClassicEditor() {
  return getSiteHost() === 'EDITOR';
}

export function getHostEditorType(): EditorType {
  if (isHostStudio()) {
    return 'studio';
  }
  if (isHostEditor3()) {
    return 'editor3';
  }
  return 'classic';
}
